export default __webpack_public_path__ + "static/media/HYD-17.a5765bd6.webp";